import React, { useState } from 'react'
import styled from 'styled-components'
import TocList from './tocList'

import { imageUrlFor } from '../lib/image-url'
import { buildImageObj } from '../lib/helpers'

const StyledToc = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  color: rgba(0,0,0,0.9);
  padding: 50px 0px;

  @media only screen and (max-width: 900px) {
    #container {display: none;}
    #text {grid-column: 1/3;}
  }
  

  #text {

    overflow-y: scroll;
    max-height: 100vh;
    
    ul {
      border-left: 1px solid #dfdfdf;
      display: flex;
      padding-left: 30px;
      justify-content: center;
    }
  }


#container {
  height: 100%;
  position: relative;

  #placeholder {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  
    width: 80%;
    height: 80vh;
    object-fit: cover;
    background: #e0ede8;
  }

  img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  
    width: 80%;
    height: 80vh;
    object-fit: cover;
  }

  .hidden {
    visibility: hidden;
    opacity: 0;
    transition: all 0s linear .5s, opacity .5s;
  }
  .visible {
    visibility: visible;
    opacity: 1;
    transition: all 0s linear 0s, opacity .5s;
  }
}
`


const ToC = ({ allContent }) => {

  const [match, setMatch] = useState({ _id: null })

  const switchPicture = (id) => {
    const matching = allContent.find(r => r._id === id)
    console.log(matching)
    setMatch(matching)
  }

  return (
    <StyledToc>
      <div id="container">
        {match._id === null && <div id="placeholder"></div>}
        {
          allContent.map(c => {
              return (
                <img className={(c._id === match._id) ? "visible" : "hidden"}
                  src={imageUrlFor(buildImageObj(c.mainImage))
                    .width(1200)
                    .height(Math.floor((9 / 16) * 1200))
                    .fit('crop')
                    .url()}
                />
              )
          })
        }
      </div>
      <section id="text">
        <TocList onHover={(id) => switchPicture(id)} />
      </section>
    </StyledToc>
  )

}

export default ToC